import { ComponentType } from '@interfaces/component-type';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const TEXT_CLASS = 'font';
const PHOTO_CLASS = 'camera';
const CONFIRM_CLASS = 'toggle-on';
const DATE_CLASS = 'calendar';
const SELECT_CLASS = 'list-ul';
const MATRIX_CLASS = 'table';
const GOTO_CLASS = 'object-group';
const SELECTAPI_CLASS = 'list-ul';
const TREEVIEW_CLASS = 'indent';
const NUMBER_CLASS = 'sort-numeric-up';
const TIME_CLASS = 'clock';
const PHRASE_CLASS = 'comment-alt';
const IMAGE_CLASS = 'image';
const AUDIO_CLASS = 'microphone';
const VIDEO_CLASS = 'video';
const SUM_CLASS = 'plus';
const GPS_CLASS = 'map-marker-alt';
const MODEL_CLASS = 'cube';
// const SAMPLETEXT_CLASS = 'layer-group';
const DRAW_CLASS = 'palette';
const SAMPLEVIDEO_CLASS = 'play';
const SAMPLE_CLASS = 'vial';
const CALCULATOR_CLASS = 'calculator';
const QRCODE_CLASS = 'qrcode';
const IMAGERECOGNITION_CLASS = 'eye';
const FILEUPLOAD_CLASS = 'file-upload';


const TaskIconDictionary = new Map<ComponentType, IconProp>([
    [ComponentType.PHOTO, PHOTO_CLASS],
    [ComponentType.TEXT, TEXT_CLASS],
    [ComponentType.CONFIRM, CONFIRM_CLASS],
    [ComponentType.DATE, DATE_CLASS],
    [ComponentType.SELECT, SELECT_CLASS],
    [ComponentType.MATRIX, MATRIX_CLASS],
    [ComponentType.GOTO, GOTO_CLASS],
    [ComponentType.SELECTAPI, SELECTAPI_CLASS],
    [ComponentType.TREEVIEW, TREEVIEW_CLASS],
    [ComponentType.NUMBER, NUMBER_CLASS],
    [ComponentType.DURATION, TIME_CLASS],
    [ComponentType.SAMPLETEXT, PHRASE_CLASS],
    [ComponentType.SAMPLEIMAGE, IMAGE_CLASS],
    [ComponentType.SAMPLEVIDEO, SAMPLEVIDEO_CLASS],
    [ComponentType.AUDIO, AUDIO_CLASS],
    [ComponentType.VIDEO, VIDEO_CLASS],
    [ComponentType.SCORE, SUM_CLASS],
    [ComponentType.GPS, GPS_CLASS],
    [ComponentType.MODEL, MODEL_CLASS],
    // [ComponentType.GOTO, SAMPLETEXT_CLASS]
    [ComponentType.DRAW, DRAW_CLASS],
    [ComponentType.SAMPLE, SAMPLE_CLASS],
    [ComponentType.CALCULATOR, CALCULATOR_CLASS],
    [ComponentType.QRCODE, QRCODE_CLASS],
    [ComponentType.IMAGERECOGNITION, IMAGERECOGNITION_CLASS],
    [ComponentType.FILEUPLOAD, FILEUPLOAD_CLASS]
]);

export default TaskIconDictionary;